import * as i0 from '@angular/core';
import { NgModule, Optional, SkipSelf, Injectable, InjectionToken } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BehaviorSubject, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import * as i1 from '@angular/common/http';

class SharedModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: SharedModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.7", ngImport: i0, type: SharedModule, imports: [RouterModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: SharedModule, imports: [RouterModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: SharedModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [
                        RouterModule
                    ],
                    exports: [],
                    providers: []
                }]
        }] });

class AnbNgConfiguratieModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error("AnbNgConfiguratieModule is already loaded. Import it in the AppModule only");
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: AnbNgConfiguratieModule, deps: [{ token: AnbNgConfiguratieModule, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.7", ngImport: i0, type: AnbNgConfiguratieModule, imports: [SharedModule, CommonModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: AnbNgConfiguratieModule, imports: [SharedModule, CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: AnbNgConfiguratieModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [SharedModule, CommonModule],
                    exports: [],
                    providers: [],
                }]
        }], ctorParameters: function () { return [{ type: AnbNgConfiguratieModule, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }]; } });

class AnbNgConfiguratieService {
    constructor(http, configService) {
        this.http = http;
        this.apiV1Path = '/api/v1/configuraties';
        this.store = new BehaviorSubject([]);
        this.store$ = this.store.asObservable();
        this.getValue = (key) => this.store.value.find((k) => k.key === key)?.value;
        this.getConfiguration$ = (settings) => this.http
            .post(`${settings.basePath}${this.apiV1Path}`, settings.keys)
            .pipe(map((configurations) => {
            this.store.next(configurations);
            return true;
        }), catchError((err) => {
            console.error('unable to fetch the configuration');
            console.log(err);
            return of(false); // To make sure the application can start, even without the configuration
        }));
        if (configService) {
            throw new Error('AnbNgConfiguratieService already loaded');
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: AnbNgConfiguratieService, deps: [{ token: i1.HttpClient }, { token: AnbNgConfiguratieService, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: AnbNgConfiguratieService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: AnbNgConfiguratieService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: AnbNgConfiguratieService, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }]; } });

const ANB_CONFIGURATIE_DATA_SETTINGS = new InjectionToken('configuratie-data-settings');

/*
 * Public API Surface of anb-ng-configuratie
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ANB_CONFIGURATIE_DATA_SETTINGS, AnbNgConfiguratieModule, AnbNgConfiguratieService };
